<template>
  <div>
    <div class="page-header clear-filter" filter-color="orange">
      <parallax class="page-header-image" style="background-image:url('img/header-bg-1.jpg')"></parallax>
      <div class="container">
        <div class="content-center brand">
          <img class="n-logo" src="img/sym-n-logo.png" alt="SYMnergetics" />
        </div>
      </div>
    </div>
    <div class="section section-about-us">
      <div class="container">
        <div class="row">
          <div class="col ml-auto mr-auto text-center">
            <h2 class="title">Who we are?</h2>
            <div class="row">
              <div class="col-md-2">
                <picture>
                  <source srcset="img/cidb-logo-trans.webp" type="image/webp" class="img-fluid" />
                  <img src="img/cidb-logo-trans.png" alt="CIDB Logo" class="img-fluid mb-3" />
                </picture>
              </div>
              <div class="col text-left">
                <p>SYMNERGETICS offers end-to-end engineering and technical services, tailored to your needs. We are a CIDB certified company specialising in the oil and gas, industrial, and the marine sector.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="separator separator-primary"></div>
    <div class="section section-work-value">
      <div class="container">
        <div class="row">
          <div class="col-md-6 text-center">
            <picture>
              <source srcset="img/unsplash-1.webp" type="image/webp" class="img-fluid" />
              <img src="img/unsplash-1.png" alt="Section Image" class="img-fluid" />
            </picture>
          </div>
          <div class="col-md-6 align-top">
            <h3 class="title">HOW WE WORK - DELIVERING VALUE</h3>
            <div class="container text-left">
              <h4>
                <span class="text-primary">1.</span> CUSTOMISED SERVICE
              </h4>
              <p class="description">
                We approach every project from a unique
                perspective. We believe in producyive collaborations and working a
                project closely with our stakeholders and partners to provide
                exceptional and efficient service – anywhere, anytime.
              </p>
              <h4>
                <span class="text-primary">2.</span> STRATEGIC IMPLEMENTATION
              </h4>
              <p class="description">
                We look beyond the obvious and strategise a plan for
                our project every step of the way to ensure a smooth
                and successful implementation process.
              </p>
              <h4>
                <span class="text-primary">3.</span> ASSURANCE - PEACE OF MIND
              </h4>
              <p class="description">
                We make sure to have the right people on
                board our team – people with the right
                passion, skill set and atitude. Together,
                we are confident that we can meet all
                your project requirements (budget
                and timeline; compliance and
                quality). We believe in integrity –
                this means honesty and transparency. We listen and are
                committed to keeping you
                informed every stage of
                your project.
              </p>
              <h4>
                <span class="text-primary">4.</span> HEALTH
                & SAFETY
              </h4>
              <p class="description">
                We take the
                health and
                safety of our
                employees and
                partners at workplace
                seriously. Unsafe act /
                condition will be notified
                with a stop work policy.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="separator separator-primary"></div>
    <div class="section section-contact-us text-center">
      <div class="container">
        <h2 class="title">Let's get in touch</h2>
        <p>
          Download our company brochure
          <a
            href="https://go.sym-n.com/about-sym"
            target="_blank"
          >here</a> or get in touch with us now by leaving us your details below
        </p>
        <div class="row" v-if="formSubmitted">
          <div class="col-lg-6 text-center ml-auto mr-auto col-md-8">
            <div class="py-5">
              <h5 class="text-info">Thank you {{ form.name }}, we will be in touch!</h5>
            </div>
          </div>
        </div>
        <div class="row" v-else>
          <div class="col-lg-6 text-center ml-auto mr-auto col-md-8">
            <alert type="danger" dismissible v-if="this.formError.length > 0">
              <div class="alert-icon">
                <i class="now-ui-icons objects_support-17"></i>
              </div>
              <strong>Oh snap!</strong> Change a few things up and try submitting again.
            </alert>
            <form>
              <fg-input
                class="input-lg"
                placeholder="Your name"
                v-model="form.name"
                addon-left-icon="now-ui-icons users_circle-08"
              ></fg-input>
              <fg-input
                class="input-lg"
                placeholder="Your e-mail"
                v-model="form.email"
                addon-left-icon="now-ui-icons ui-1_email-85"
              ></fg-input>
              <fg-input
                class="input-lg"
                placeholder="Your mobile contact"
                v-model="form.mobileNo"
                addon-left-icon="now-ui-icons tech_mobile"
              ></fg-input>
              <div class="textarea-container">
                <textarea
                  class="form-control"
                  name="name"
                  rows="6"
                  cols="80"
                  v-model="form.message"
                  placeholder="Type a message..."
                ></textarea>
              </div>
              <div class="send-button">
                <n-button
                  type="primary"
                  round
                  block
                  size="lg"
                  @click="onSubmit"
                  :disabled="$v.form.$invalid"
                >Send Message</n-button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="separator separator-primary"></div>
  </div>
</template>
<script>
import axios from "axios";
import { validationMixin } from "vuelidate";
import {
  email,
  required,
  minLength,
  maxLength
} from "vuelidate/lib/validators";
import { Parallax } from "@/components";
import { Alert, Button, FormGroupInput } from "@/components";

export default {
  mixins: [validationMixin],
  name: "index",
  bodyClass: "index-page",
  components: {
    Parallax,
    Alert,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput
  },
  data() {
    return {
      formSubmitted: false,
      formError: "",
      form: {
        name: "",
        email: "",
        mobileNo: "",
        message: ""
      }
    };
  },
  validations: {
    form: {
      name: { required, minLength: minLength(3), maxLength: maxLength(100) },
      email: {
        required,
        email,
        minLength: minLength(3),
        maxLength: maxLength(150)
      },
      mobileNo: { minLength: minLength(5), maxLength: maxLength(50) },
      message: { required, minLength: minLength(3), maxLength: maxLength(500) }
    }
  },
  methods: {
    async onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        console.log(this.$v.form.$anyError);
        return;
      }

      const formMessage = `From: ${this.form.name}\nEmail: ${this.form.email}\nContact Number: ${this.form.mobileNo}\nMessage:
        ${this.form.message}`;

      try {
        axios.defaults.timeout = 3500;
        const response = await axios.get("https://sym-n.com/api/mail", {
          headers: {
            "content-type": "application/json"
          },
          params: {
            name: this.form.name,
            email: this.form.email,
            message: formMessage
          },
          timeout: 1000 * 3.5 // Wait for 5 seconds
        });

        this.formSubmitted = true;
      } catch (error) {
        this.formError = error.toString();
      }

      // axios
      //   .get("https://sym-n.com/api/mail", {
      //     headers: {
      //       "content-type": "application/json"
      //     },
      //     params: {
      //       name: this.form.name,
      //       email: this.form.email,
      //       message: formMessage
      //     },
      //     timeout: 1000 * 5 // Wait for 5 seconds
      //   })
      //   .then(response => {
      //     // console.log(response);
      //     this.formSubmitted = true;
      //   })
      //   .catch(error => {
      //     // console.log(error);
      //     this.formError = err.toString();
      //   });
    }
  }
};
</script>
